// extracted by mini-css-extract-plugin
export default {"shadowed":"Experience_shadowed__Wrq4M","pink":"Experience_pink__p6sEo","green":"Experience_green__ZSvUM","skills":"Experience_skills__BJG1C"};